<template>
    <m-onestep
        title="Verify - Drivers License"
        reportUrl="/verify2/driverslicense"
        :postForm="true"
        productId="58"
        :fields="[
            { label: 'ID Number / Passport', name: 'idNumber', required: true, type: 'text' },
            {label: 'First Name', name: 'name', required: true, type: 'text'},
            {label: 'Surname', name: 'surname', required: true, type: 'text'},
            {name:'drivers-prompt', type: 'custom'},
            {label: 'Drivers License', name: 'driverslicenseDocument', required: true, type: 'fileupload'},
            {name:'custom-text', type: 'custom'},
            {label: 'Email', type: 'static', name: 'email',  value: $initial.userEmail},
            {label: 'Contact Number', name: 'contactNumber', required: true, type: 'text'},
            {label: 'Reference', name: 'reference', required: false, type: 'text'},
            {label: 'I agree to all the terms and conditions', name: 'accept', required: true, type: 'checkbox'}
        ]">

        <template v-slot:top>
            <div class="text-base">This enquiry determines if the individual has a valid drivers license.</div>
            <div class="p-2 text-primary-600">Please supply the following details:</div>
        </template>

        <template v-slot:custom-text="{field, update}">
            <div class="text-primary-600">Please supply your Contact Details and Reference:</div>
        </template>
        <template v-slot:drivers-prompt="{field, update}">
            <div class="text-primary-600">Please upload a copy of the Drivers License:</div>
        </template>

        <template v-slot:bottom>
            <Disclaimer></Disclaimer>
        </template>
    </m-onestep>
</template>

<script>
import Disclaimer from "@/pages/verify/disclaimer.vue";

export default {
    components: {
        Disclaimer,
    },
};
</script>
